import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    private router: Router
  ) { }
  set setToken(token: any) {
    localStorage.setItem('arc_token', token)
  }

  get getToken() {
    if (localStorage.getItem('arc_token')) {
      return localStorage.getItem('arc_token')
    }
    else {
      return null
    }
  }

  logOut() {
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  bodyRequiredValidator = (body: any, fields: string[]): object | undefined => {
    let required: string[] = []
    fields.forEach((key) => {
      if ([undefined, '', null].includes(body[key])) {
        required.push(key)
      }
    })
    return required.length ? { "missing": required } : undefined
  }
}
